"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerAddress = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
const default_shipping_info_model_1 = require("./default-shipping-info.model");
class PartnerAddress extends common_1.MongoSubDocument {
    get display() {
        const lines = this.address ? this.address.split(/\n/) : [];
        if (this.country === 'US') {
            let line = this.city || '';
            if (this.state)
                line = line ? `${line}, ${this.state}` : this.state;
            if (this.zip)
                line = line ? `${line} ${this.zip}` : this.zip;
            lines.push(line);
        }
        if (this.country)
            lines.push(this.country);
        return lines.join('\n');
    }
}
exports.PartnerAddress = PartnerAddress;
//# sourceMappingURL=partner-address.model.js.map